
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-branches/[url_slug]",
      function () {
        return require("private-next-pages/our-branches/[url_slug]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-branches/[url_slug]"])
      });
    }
  